import { Menu, X } from 'lucide-react';
import { useState, type ReactNode } from 'react';
import { contactDetails, navigation, siteIdentity } from '../content/siteContent';

export function PublicLayout({ children }: { children: ReactNode }) {
  const [menuOpen, setMenuOpen] = useState(false);
  const currentPath = window.location.pathname;

  return (
    <div className="site-shell">
      <a className="skip-link" href="#main-content">Skip to content</a>
      <header className="site-header">
        <a className="wordmark" href="/" aria-label={`${siteIdentity.name} home`}>
          <span>{siteIdentity.name}</span>
        </a>
        <button
          className="menu-toggle"
          type="button"
          aria-expanded={menuOpen}
          aria-controls="site-navigation"
          aria-label={menuOpen ? 'Close menu' : 'Open menu'}
          onClick={() => setMenuOpen((open) => !open)}
        >
          {menuOpen ? <X aria-hidden="true" /> : <Menu aria-hidden="true" />}
        </button>
        <nav id="site-navigation" className="site-nav" data-open={menuOpen} aria-label="Main">
          {navigation.map((item) => (
            <a
              key={item.href}
              href={item.href}
              aria-current={currentPath === item.href ? 'page' : undefined}
              onClick={() => setMenuOpen(false)}
            >
              {item.label}
            </a>
          ))}
        </nav>
      </header>
      <main id="main-content">{children}</main>
      <footer className="site-footer">
        <ul className="site-footer__contact">
          {contactDetails.email && <li><a href={`mailto:${contactDetails.email}`}>{contactDetails.email}</a></li>}
          {contactDetails.phone && <li><a href={contactDetails.phoneHref}>{contactDetails.phone}</a></li>}
          {contactDetails.address && <li>{contactDetails.address}</li>}
        </ul>
        <p className="site-footer__legal">© {new Date().getFullYear()} {siteIdentity.name}</p>
      </footer>
    </div>
  );
}
